import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EnvironmentService } from '@nomoh-monorepo/shared-data-access-environment';
import {
  IPagerSettings,
  ISimplifiedNode,
  ITipoFluxoNomoh,
} from '@nomoh-monorepo/shared-types';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureFluxoService {
  private http = inject(HttpClient);
  private env = inject(EnvironmentService);

  async findAll(
    filtro: Record<string, unknown>,
    pagerSettings: IPagerSettings
  ) {
    return firstValueFrom(
      this.http.post<{
        data: ITipoFluxoNomoh[];
        pagerSettings: IPagerSettings;
      }>(`${this.env.$apiUrls().nomoh}/fluxo/findAll`, {
        ...filtro,
        ...pagerSettings,
      })
    );
  }

  async findById(id: string) {
    return firstValueFrom(
      this.http.get<ITipoFluxoNomoh>(`${this.env.$apiUrls().nomoh}/fluxo/${id}`)
    );
  }

  async create(data: Partial<ITipoFluxoNomoh>) {
    return firstValueFrom(
      this.http.post<string>(`${this.env.$apiUrls().nomoh}/fluxo`, data)
    );
  }

  async update(id: string, data: Partial<ITipoFluxoNomoh>) {
    return firstValueFrom(
      this.http.put<void>(`${this.env.$apiUrls().nomoh}/fluxo/${id}`, data)
    );
  }

  async delete(id: string) {
    return firstValueFrom(
      this.http.delete<void>(`${this.env.$apiUrls().nomoh}/fluxo/${id}`)
    );
  }

  /**
   * Busca os nodes de um workflow N8N
   * @param workflowId ID do workflow no N8N
   * @returns Lista de nodes simplificados com formato $('Node Name')
   */
  async getWorkflowNodes(workflowId: string) {
    return firstValueFrom(
      this.http.get<ISimplifiedNode[]>(
        `${this.env.$apiUrls().nomoh}/fluxo/workflow-nodes/${workflowId}`
      )
    );
  }
}
